/* global axios */
import ApiClient from './ApiClient';

// Cloud Inspire (#2/M21.1) — the static dashboard token, delivered via
// window.globalConfig (present in <head> before JS boot, so it never races the
// Devise session headers). Sent as X-CI-Copilot-Token on this client's calls only
// — never added to axios.defaults, so it stays off every other request.
const ciHeaders = () => {
  const token = window.globalConfig?.cloudInspireCopilotToken;
  return token ? { 'X-CI-Copilot-Token': token } : {};
};

// Cloud Inspire (#124) — reads the per-inbox Copilot menu actions through the
// authenticated Rails proxy (GET /api/v1/accounts/:id/cloud_inspire/copilot_actions).
// The proxy holds the shared secret; the browser only sees { actions: [...] }.
class CloudInspireCopilotActionsAPI extends ApiClient {
  constructor() {
    super('cloud_inspire/copilot_actions', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(this.url, {
      params: { conversation_id: conversationId },
      headers: ciHeaders(),
    });
  }

  // Cloud Inspire (#127) — inbox-keyed actions for the new-conversation composer
  // (no conversation exists yet). The proxy forwards to <base>/inboxes/:id/actions.
  getByInbox(inboxId) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId },
      headers: ciHeaders(),
    });
  }

  // Cloud Inspire (#131) — a "content" (target=reply) action: run the preset
  // prompt through our agent and get back { answer } to draft into the reply box.
  // Posts to the sibling proxy <account>/cloud_inspire/copilot_reply; with a
  // conversationId the backend uses the inbox bot + conversation context, without
  // one it answers generally (composer).
  reply({ prompt, conversationId }) {
    const url = this.url.replace(/copilot_actions$/, 'copilot_reply');
    return axios.post(
      url,
      { prompt, conversation_id: conversationId },
      { headers: ciHeaders() }
    );
  }
}

export default new CloudInspireCopilotActionsAPI();
